import type { FC, PropsWithChildren } from 'react'

import CheckIcon from 'mdi-react/CheckIcon'

export const SuccessMessage: FC<PropsWithChildren> = ({ children }) => (
  <div className="p-0.5">
    <div className="container mx-auto">
      <div className="flex items-center">
        <CheckIcon color="green" />
        <p className="text-small my-0 ml-2">{children}</p>
      </div>
    </div>
  </div>
)
